import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';

/**
 * Make sure segment exists adn has that function
 * @param {String} fcnName - Function name
 * @return {boolean} does the fucntion exist
 */
function hasSegmentFunction(fcnName) {
  return canUseDom() ? window.analytics && typeof window.analytics[fcnName] === 'function' : false;
}

/**
 * Get the user anonymousID
 * @return {String} the user anonymousId
 */
function getAnonymousId() {
  return hasSegmentFunction('user') ? window.analytics.user().anonymousId() : '';
}

/**
 * Reset the user is including anonymousID
 * @return {void}
 */
function resetUser() {
  if (hasSegmentFunction('reset')) {
    window.analytics.reset();
  }
}

/**
 * Export the segment library by default
 */
var index = canUseDom() ? window.analytics : false;
export default index;
export { getAnonymousId, hasSegmentFunction, resetUser };